var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('update-details-form',{attrs:{"user":_vm.user,"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }